module.exports = __webpack_public_path__ + "static/img/dq2.51ca613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq2.png
// module id = xHuM
// module chunks = 0